module.exports = __webpack_public_path__ + "img/SimplificadaIcon.05e72261.svg";